<template lang="pug">
  .event-page-wrapper
    .event-page
      p.event-page__title-date {{ dateTitle }}

      VueHorizontalCalendar.event-page__horizontal-calendar(
        choosedDatePos="center"
        swipeSpace="3"
        :available-dates="availableDates"
        v-model="date"
        tileWidth="66"
        :choosed-date="initialChoosedDate"
      )

      .event-page__main(:class="{'no-events': this.isNoEvents}")
        transition(name="fade")

          .spinner.event-page__spinner(v-if="isShowPreloader")

          PlaceholderTip.event-page__placeholder-tip(
            v-else-if="isNoEvents"
            text="Сеансы отсутствуют"
            icon="calendar"
          )

          component(
            v-else
            :is="gridComponent"
            :data="availableEvents")

      .event-page__footer(v-show="!isNoEvents")
        button.event-page__footer-button.button(
          @click="clearHandler"
          :disabled="isNoCurrentEvents"
        ) Отменить
        button.event-page__footer-button.button.button--primary(
          @click="$router.push('/')"
          :disabled="isNoCurrentEvents"
        ) Выбрать

</template>

<script>
import VueHorizontalCalendar from '@/components/HorizontalCalendar/HorizontalCalendar';
import PlaceholderTip from "@/components/PlaceholderTip";
import {mapActions, mapGetters, mapMutations} from "vuex";
import {VIEW_TYPE} from "@/components/EventGrid/constants";

export default {
  name: "EventList",
  components: {
    VueHorizontalCalendar,
    PlaceholderTip
  },
  data() {
    return {
      date: {},
      isShowPreloader: false,
      gridViewType: null,
    }
  },
  beforeMount() {
    this.clearAvailableEvents();

    this.gridViewType = this.currentPersonId
        ? VIEW_TYPE.DEFAULT
        : VIEW_TYPE.GROUPED;

    this.fetchDates().then(() => {
      if (this.getCurrentDate === null) {
        console.log('[EventList.vue] Выбранная дата по умолчанию установлена:', this.availableDates[0])
        this.setCurrentDate(this.availableDates[0]);
      }
    })
  },
  beforeRouteLeave(to, from, next) {
    if (this.gridViewType === VIEW_TYPE.GROUPED
        && this.currentEvents.length === 0) {
      this.clearPerson();
    }
    next();
  },
  computed: {
    ...mapGetters('person', ['currentPersonId']),
    ...mapGetters('event', ['getCurrentDate']),
    ...mapGetters('event', {
      availableDates: 'getAllDates',
      availableEvents: 'getAllEvents',
      isNoCurrentEvents: 'isNoCurrentEvents',
      currentEvents: 'getCurrentEvents'
    }),
    initialChoosedDate() {
      return this.getCurrentDate || new Date();
    },
    gridComponent() {
      return this.gridViewType === VIEW_TYPE.DEFAULT
          ? () => import(/* webpackChunkName: "DefaultEventGrid" */ '../components/EventGrid/DefaultEventGrid/DefaultEventGrid')
          : () => import(/* webpackChunkName: "GroupedEventGrid" */ '../components/EventGrid/GroupedEventGrid/GroupedEventGrid')
    },
    dateTitle() {
      const date = new Date(this.date?.timestamp) || new Date();
      return date.toLocaleDateString(
          'ru',
          {
            weekday: 'long',
            year: 'numeric',
            month: 'long',
            day: 'numeric'
          });
    },
    isNoEvents() {
      return !this.availableEvents.length;
    },
  },
  watch: {
    date(newValue, oldValue) {
      const {epochTimestamp} = newValue;
      const oldEpochTimestamp = oldValue.epochTimestamp;

      if (!this.availableDates.includes(epochTimestamp)) {
        return console.log('[EventList.vue] Запрос событий прерван...\nВыбранной даты по умолчанию нет в списке доступных:', epochTimestamp);
      }

      if (oldEpochTimestamp === epochTimestamp) {
        return console.log('[EventList.vue] Повторный запрос событий прерван...')
      }

      this.setCurrentDate(epochTimestamp);
      this.isShowPreloader = true;
      this.gridViewType = this.currentPersonId
          ? VIEW_TYPE.DEFAULT
          : VIEW_TYPE.GROUPED;
      this.$nextTick(() => {

        this.fetchEvents({epochTimestamp: epochTimestamp, viewType: this.gridViewType})
            .then(() => this.isShowPreloader = false);
        //  .then(() => setTimeout(() => this.isShowPreloader = false, 700));
        //   убрать таймаут (он просто для проверки прелоадера)
      });
    },
  },
  methods: {
    ...mapMutations('person', ['clearPerson']),
    ...mapMutations('event', ['setCurrentDate', 'clearAvailableEvents']),
    ...mapActions('event', {
      clearCurrentEvents: 'clearEvents',
      fetchDates: 'fetchDates',
      fetchEvents: 'fetchEvents',
    }),
    clearHandler() {
      if (this.gridViewType === VIEW_TYPE.GROUPED) {
        this.clearPerson();
      }
      this.clearCurrentEvents();
    },
  }
}
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity .2s;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>
